import { createApp } from "vue";
import { pt } from "./assets/locale/pt.json";
import "@/assets/styles.scss";
import App from "./components/App.vue";
import "primeflex/primeflex.min.css";
import "primeicons/primeicons.css";
import router from "@/router/routerConfig";
import api from "@/stores/api.js";
import { definePreset } from "@primevue/themes";
import Aura from "@primevue/themes/aura";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import Badge from "primevue/badge";
import Button from "primevue/button";
import Calendar from "primevue/calendar";
import Card from "primevue/card";
import Chip from "primevue/chip";
import Column from "primevue/column";
import PrimeVue from "primevue/config";
import ConfirmationService from "primevue/confirmationservice";
import ConfirmPopup from "primevue/confirmpopup";
import DataTable from "primevue/datatable";
import Dialog from "primevue/dialog";
import Divider from "primevue/divider";
import Dropdown from "primevue/dropdown";
import Fieldset from "primevue/fieldset";
import FileUpload from "primevue/fileupload";
import Image from "primevue/image";
import InlineMessage from "primevue/inlinemessage";
import InputGroup from "primevue/inputgroup";
import InputNumber from "primevue/inputnumber";
import InputText from "primevue/inputtext";
import Menubar from "primevue/menubar";
import MultiSelect from "primevue/multiselect";
import Panel from "primevue/panel";
import ProgressBar from "primevue/progressbar";
import ProgressSpinner from "primevue/progressspinner";
import RadioButton from "primevue/radiobutton";
import Ripple from "primevue/ripple";
import Select from "primevue/select";
import Sidebar from "primevue/sidebar";
import Skeleton from "primevue/skeleton";
import Steps from "primevue/steps";
import Tab from "primevue/tab";
import TabList from "primevue/tablist";
import TabPanel from "primevue/tabpanel";
import TabPanels from "primevue/tabpanels";
import Tabs from "primevue/tabs";
import Tag from "primevue/tag";
import Textarea from "primevue/textarea";
import Timeline from "primevue/timeline";
import Toast from "primevue/toast";
import ToastService from "primevue/toastservice";
import Tooltip from "primevue/tooltip";

const app = createApp(App);

const MyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: "#FFF5F0",
      100: "#FFE8DD",
      200: "#FFD1BB",
      300: "#FFA882",
      400: "#F2814D",
      500: "#E84910",
      600: "#D13F0E",
      700: "#C13A0D",
      800: "#9A2E0A",
      900: "#732208",
      950: "#4D1705",
    },
    formField: {
      borderRadius: "4px",
      paddingX: "1rem",
    },
    colorScheme: {
      light: {
        success: {
          color: "#28BC00",
        },
        danger: {
          color: "#FC4242",
        },
        warn: {
          color: "#FF9800",
        },
        info: {
          color: "#007DFF",
        },
      },
    },
  },
});

app.use(PrimeVue, {
  ripple: true,
  locale: pt,
  theme: {
    preset: MyPreset,
    options: {
      darkModeSelector: "none",
    },
  },
});

app.use(router);

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

app.provide("axios", api);
app.use(ConfirmationService);
app.use(ToastService);
app.use(pinia);
app.component("Card", Card);
app.component("Button", Button);
app.component("Dialog", Dialog);
app.component("RadioButton", RadioButton);
app.component("DataTable", DataTable);
app.component("Column", Column);
app.component("InputText", InputText);
app.component("InputNumber", InputNumber);
app.component("Textarea", Textarea);
app.component("FileUpload", FileUpload);
app.component("InputGroup", InputGroup);
app.component("Skeleton", Skeleton);
app.component("Select", Select);
app.component("ProgressSpinner", ProgressSpinner);
app.component("MultiSelect", MultiSelect);
app.component("Tabs", Tabs);
app.component("Tab", Tab);
app.component("TabList", TabList);
app.component("TabPanels", TabPanels);
app.component("TabPanel", TabPanel);
app.component("ConfirmPopup", ConfirmPopup);
app.component("Fieldset", Fieldset);
app.component("Chip", Chip);
app.component("Divider", Divider);
app.component("Image", Image);
app.component("Menubar", Menubar);
app.component("Toast", Toast);
app.component("Tag", Tag);
app.component("InlineMessage", InlineMessage);
app.component("Badge", Badge);
app.component("Timeline", Timeline);
app.component("Sidebar", Sidebar);
app.component("ProgressBar", ProgressBar);
app.component("Calendar", Calendar);
app.component("Dropdown", Dropdown);
app.component("Steps", Steps);
app.component("Panel", Panel);
app.directive("ripple", Ripple);
app.directive("tooltip", Tooltip);
app.mount("#app");
